<template>
  <q-card>
    <q-card-section class="bg-primary text-white q-py-sm text-subtitle1">
      Settings
    </q-card-section>

    <q-card-section class="q-mt-lg">
      <div v-for="(setting, index) in dataSettings" :key="`settings_${index}`" class="row q-mb-xl">
        <div v-if="setting.description" class="col-md-12">
          <p>
            <strong>{{ setting.description }}</strong>
          </p>
        </div>
        <!-- checkbox settings -->
        <q-field v-if="setting.data_type === 'boolean'" class="col-md-6">
          <q-checkbox
            :id="setting.name"
            v-model="setting.value"
            :name="setting.name"
            :label="setting.label"
            class="lm-checkbox"
          />
        </q-field>
        <!-- number settings -->
        <q-input
          v-else-if="setting.data_type === 'integer'"
          :id="setting.name"
          v-model="setting.value"
          :name="setting.name"
          :label="setting.label"
          :min="0"
          stack-label
          class="col-md-6"
          type="number "
          outlined
        />
        <!-- normal input settings -->
        <q-input
          v-else
          :id="setting.name"
          v-model="setting.value"
          :label="setting.label"
          :name="setting.name"
          stack-label
          class="col-md-6"
          outlined
        />
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
export default {
  props: {
    dataSettings: {
      type: Array,
      required: true
    }
  }
}
</script>
